import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useMemo,
  useLayoutEffect,
} from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Input,
  FormGroup,
  Label,
  Tooltip,
} from "reactstrap";
import { toast } from "react-toastify";

import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import withRedirect from "../../hoc/withRedirect";
import AuthService from "../../services/authenticationService";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import InputMask from "react-input-mask";
import classNames from "classnames";
import SikkaError from "../common/SikkaError";
import Flex from "../common/Flex";
import { Link } from "react-router-dom";
import AuthCardLayout from "./AuthCardLayout";
import LoadingButton from "../common/LoadingButton";
import { useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faRightLong } from "@fortawesome/free-solid-svg-icons";
import { GetParamterFromLink } from "../../helpers/utils";
import { urlRegex } from "../../helpers/CONSTANT";
import authenticationService from "../../services/authenticationService";
import SikkaSelect from "../common/SikkaSelect/SikkaSelect";
import MaskedInput from "react-text-mask";

const RegistrationFormNew = ({
  setRedirect,
  hasLabel,
  setRedirectUrl,
  step,
  setStep,
  setRegisterFormValues,
  registerFormValues,
}) => {
  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
    ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
    : false;
  const [devPhone, setDevPhone] = useState("");
  const [devMobile, setDevMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDentalLlmSelected, setIsDentalLlmSelected] = useState(false);

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const inviteQKey = GetParamterFromLink("q");
  const inviteTKey = GetParamterFromLink("t");
  const isTokenExist = GetParamterFromLink("token");
  const [licenseType, setLicenseType] = useState(null);
  const [defaultSelectedPlan, setDefaultSelectedPlan] = useState({});
  const [isTCReaded, setIsTCReaded] = useState(false)
  const {
    register,
    errors,
    watch,
    handleSubmit,
    reset,
    control,
    setValue,
    setError,
    clearError,
    unregister
  } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (!isApiPlusExist) {
      authenticationService
      .apiPlans("yes")
      .then((res) => {
        setLicenseType(res.items);
      })
      .catch((error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error("Something went wrong.Please try again later");
      });
    }
  }, []);

  useEffect(() => {
    if (isApiPlusExist) {
      setDevMobile(devPhone);
      unregister("mobileNo");
    }
  }, [devPhone]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     reset({
  //       plan_id: "4",
  //       dev_country: "United States",
  //     });
  //   };

  //   fetchData();
  // }, [reset]);

  // const location = useLocation();

  const ClearFormStates = () => {
    setDevMobile("");
    setDevPhone("");
    reset();
  };

  useEffect(() => {
    const RegisterUser = registerFormValues;

    if (window.location.href.toLowerCase().includes("register")) {
      if (RegisterUser) {
        const parseRegisterUser = RegisterUser;
        const RegisterUserKeys = Object.keys(parseRegisterUser);

        if (
          parseRegisterUser?.dev_purpose
            ?.toLowerCase()
            .includes("dentalllm/synthetic".toLowerCase())
        ) {
          setIsDentalLlmSelected(true);
        } else {
          setIsDentalLlmSelected(false);
        }

        RegisterUserKeys.map((item) => {
          if (isApiPlusExist) {
            if (item == 'first_name') {
              setValue("first_name",registerFormValues["first_name"]);
            }
            if (item == 'last_name') {
              setValue("last_name",registerFormValues["last_name"]);
            }

            if (item == "isTCReaded") {
              setIsTCReaded(registerFormValues["isTCReaded"]);
            }

          }
          setValue(item, parseRegisterUser?.[item]);
        });

        setValue("plan_id", parseRegisterUser?.["plan_id"]);
        if (parseRegisterUser["plan_id"]) {
          setDefaultSelectedPlan({
            label: licenseType?.find(
              (item) => item?.plan_id == parseRegisterUser?.plan_id
            )?.plan_name,
            value: parseRegisterUser?.["plan_id"],
          });
        } else {
          if (licenseType) {
            setDefaultSelectedPlan({
              label: licenseType[0]?.plan_name,
              value: licenseType[0]?.plan_id,
            });
            setValue("plan_id", licenseType[0]?.plan_id);
          }
        }
        setValue("confirm_password", parseRegisterUser["confirm_password"]);

        setDevMobile(parseRegisterUser["dev_mobile"]);
        setDevPhone(parseRegisterUser["dev_phone"]);
        setValue("mobileNo", parseRegisterUser["dev_mobile"]);
        setValue("phoneNumber", parseRegisterUser["dev_phone"]);
      }
    } else {
      ClearFormStates();
    }
  }, [registerFormValues, licenseType]);

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query = useQuery();

  var from_where = "DentalLLM/Synthetic Dental Data";
  if (query.get("ref")) {
    from_where = query.get("ref");
  }

  useEffect(() => {
    if (
      query.get("request") == "apiplusplus" &&
      query.get("callback_key") &&
      query.get("redirect_url") && window.location.href.includes("sai-register")
    ) {
      let storeData = {};
      storeData["redirect_url"] = query.get("redirect_url");
      storeData["callback_key"] = query.get("callback_key");
      storeData["request"] = query.get("request");
      storeData["project_id"] = query.get("project_id")
        ? query.get("project_id")
        : "";
      storeData["source_project_id"] = query.get("source_project_id")
        ? query.get("source_project_id")
        : "";
      sessionStorage.setItem("api_plus_plus", JSON.stringify(storeData));

      if (sessionStorage.getItem("pastedLinkCount")) {
        let pastedLinkCount = parseInt(
          sessionStorage.getItem("pastedLinkCount")
        );
        pastedLinkCount++;

        sessionStorage.setItem("pastedLinkCount", `${pastedLinkCount}`);
      } else {
        sessionStorage.setItem("pastedLinkCount", 1);
      }
      sessionStorage.setItem("api_plus_pasted_link", window.location.href);
    }
  }, []);
  
  const onSubmit = (values) => {
    const dentalCheckBox =
      ".I am interested in DentalLLM/Synthetic Dental Data";

    let devPurposeWithDentalLLM = isDentalLlmSelected
      ? values.dev_purpose.includes(dentalCheckBox)
        ? values.dev_purpose // If it's already included, don't append
        : `${values.dev_purpose}${dentalCheckBox}`
      : values.dev_purpose?.replace(dentalCheckBox, "");

    const fullName = isApiPlusExist ? values.first_name + " " +values.last_name : values.dev_name;

    let storeData = {
      username: values.username,
      password: values.password,
      dev_name: fullName,
      dev_address: values.dev_address,
      dev_phone: devPhone,
      dev_mobile: isApiPlusExist ? devPhone : devMobile,
      dev_city: values.dev_city,
      dev_state: values.dev_state,
      dev_country: values.dev_country,
      dev_zip: values.dev_zip,
      dev_site_url: isApiPlusExist ? isApiPlusExist["redirect_url"] : values.dev_site_url,
      dev_purpose: isApiPlusExist ? "API_PLUS_PLUS" : devPurposeWithDentalLLM,
      plan_id: isApiPlusExist ? "2" : values.plan_id, 
      referred_by: isApiPlusExist ? "" : values.referred_by,
      partner_name: fullName,
      page_type: "signup",
    };

    if (
      query.get("request") == "apiplusplus" &&
      query.get("callback_key") &&
      query.get("redirect_url")
    ) {
      storeData["redirect_url"] = query.get("redirect_url");
      storeData["callback_key"] = query.get("callback_key");
      storeData["request"] = query.get("request");
      storeData["project_id"] = query.get("project_id") || "";
      storeData["address"] = storeData.dev_address;
      storeData["zip_code"] = storeData.dev_zip;
      storeData["country"] = storeData.dev_country;
      storeData["state"] = storeData.dev_state;
      storeData["city"] = storeData.dev_city;
      storeData["first_name"] = values?.first_name;
      storeData["last_name"] = values?.last_name;
    };

    if (isApiPlusExist) {
      storeData["isTCReaded"] = isTCReaded;
    }
    setRegisterFormValues({...storeData,...values});
    showLoader();
    setLoading(true);

    if (isTokenExist || (inviteQKey && inviteTKey)) {
      if (inviteQKey && inviteTKey) {
        let inviteBody = {
          username: values.username,
          password: values.password,
          dev_name: values.dev_name,
          dev_address: values.dev_address,
          dev_phone: devPhone,
          dev_mobile: devMobile,
          dev_city: values.dev_city,
          dev_state: values.dev_state,
          dev_country: values.dev_country,
          dev_zip: values.dev_zip,
          dev_site_url: values.dev_site_url,
          dev_purpose: devPurposeWithDentalLLM,
          partner_name: values.partner_name,
          parent_devid: detailsFromInviteLink?.parent_dev_id, // partner_details_from_link
          plan_id: values.plan_id, // partner_details_from_link
          sla_plan_id: detailsFromInviteLink?.sla_plan_id,
          add_updated_by: values.username,
          page_type: "add_team_member", // partner_details_from_link
        };

        AuthService.RegisterTeamMember("add_team_member", inviteBody)
          .then((response) => {
            setRedirectUrl( `${process.env.PUBLIC_URL}/authentication/login`);
            setRedirect(true);
            setLoading(false);
            hideLoader();
            toast.success("Register successfully!");
          })
          .catch((error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            hideLoader();
            toast.error(resMessage);
            setLoading(false);
          });
      } else {
        const tokenBody = {
          username: values.username,
          password: values.password,
          dev_name: values.dev_name,
          dev_address: values.dev_address,
          dev_phone: devPhone,
          dev_mobile: devMobile,
          dev_city: values.dev_city,
          dev_state: values.dev_state,
          dev_country: values.dev_country,
          dev_zip: values.dev_zip,
          dev_site_url: values.dev_site_url,
          dev_purpose: devPurposeWithDentalLLM,
          plan_id: values.plan_id,
          referred_by: values.referred_by,
          partner_name: values.partner_name,
          page_type: "signup", // Hardcoded as "signup"
          is_vip_signup: "",
          token: isTokenExist,
        };

        AuthService.register("add_sikka_admin", tokenBody).then(
          (res) => {
            setRedirectUrl( `${process.env.PUBLIC_URL}/authentication/login`);
            setRedirect(true);
            setLoading(false);
            hideLoader();
            toast.success("Register successfully!");
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            hideLoader();
            toast.error(resMessage);
            setLoading(false);
          }
        );
      }
    } else {
      if (step == 1) {
        setStep(2);
      }
    }
  };

  const [detailsFromInviteLink, setDetailsFromInviteLink] = useState({});
  const GetDetailFromInviteLink = () => {
    if (inviteQKey && inviteTKey) {
      let body = {
        q: inviteQKey,
        t: inviteTKey,
      };
      AuthService.GetUserDetails("partner_details_from_link", body)
        .then((response) => {
          setDetailsFromInviteLink(response.data?.items);
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setDetailsFromInviteLink({});
        });
    }
  };

  useEffect(() => {
    GetDetailFromInviteLink();
  }, [inviteQKey, inviteTKey]);

  useEffect(() => {
    if (Object.values(detailsFromInviteLink) && inviteQKey && inviteTKey) {
      ["dev_site_url", "dev_purpose", "referred_by", "partner_name"].forEach(
        (item) => {
          setValue(item, detailsFromInviteLink[item]);
        }
      );
      setDevPhone(detailsFromInviteLink?.dev_phone);
      setValue("phoneNumber", detailsFromInviteLink?.dev_phone);
    }
  }, [detailsFromInviteLink]);
  return (
    <>
      {isApiPlusExist ? (
        <>
          <Row className={"mt-1 mb-2 text-center"}>
            <Col>
              <h5 className="mb-2 sai_light_text">Sign Up</h5>
              <span />
              <span className="fs--1 text-600 sai_secondary_text">
                Already User?{" "}
              </span>
              <Link
                to="/v4/portal/authentication/login"
                className="fs--1 text-600 ml-2 text_underline sai_light_text"
              >
                Login
              </Link>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Flex
            className={"mt-1 mb-1"}
            alignItems="center"
            justifyContent="between"
          >
            <span />
            <p className="mb-1 fs--1">
              <span className="fw-semi-bold">Already User? </span>
              <Link
                to="/v4/portal/authentication/login"
                className="ml-2 text-lowercase"
              >
                Login
              </Link>
            </p>
          </Flex>
        </>
      )}

      {isApiPlusExist ? (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                // label="Full Name*"
                name="first_name"
                id="first_name"
                placeholder="First Name"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "First Name is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid First Name",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                // label="Full Name*"
                name="last_name"
                id="last_name"
                placeholder="Last Name"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Last Name is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid last Name",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>
           <Row>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Email*"
                type="email"
                placeholder="Email"
                id="username"
                name="username"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Email must be valid",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Password*"
                placeholder="Password"
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Password is required",
                  pattern: {
                  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/,
                  message:
                  "Password should contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and be at least 8 characters long.",
                },
                })}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Confirm Password*"
                placeholder="Confirm Password"
                id="confirmPassword"
                name="confirm_password"
                size="sm"
                className="fs--1"
                type="password"
                autoComplete="new-password"
                innerRef={register({
                  required: "Confirm Password is required",
                  validate: (value) =>
                    value === watch("password") || "Passwords don't match.",
                })}
                errors={errors}
              />
            </Col>
          </Row>
         
          <Row className="my-3">
            <Col className="auth-input-form">
              <MaskedInput
                mask={[
                  "(",
                  /\d/,
                  /\d/,
                  /\d/,
                  ")",
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                guide={false}
                placeholder="Phone number"
                id={`phoneNumber`}
                name={`phoneNumber`}
                render={(ref, props) => {
                  return (
                    <>
                      <Input
                        type="text"
                        innerRef={ref}
                        errors={errors}
                        {...props}
                        size={"sm"}
                      />
                    </>
                  );
                }}
                {...register(`phoneNumber`, {
                  required: "Phone Number is required",
                  validate: (value) => {
                    const cleanedNumber = devPhone.replace(/[^\d]/g, "");

                    return (
                      cleanedNumber.length > 9 ||
                      "Invalid phone number. Please enter a valid 10-digit phone number."
                    );
                  },
                })}
                defaultValue={registerFormValues?.["dev_phone"]}
                value={devPhone}
                onChange={(e) => {
                  setDevPhone(e.target.value);
                  setValue(e.target.name, e.target.value);
                }}
              />
              <SikkaError
                error={errors["phoneNumber"]?.message}
                className="mt-1"
              />
            </Col>
          </Row>
          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Address*"
                placeholder="Street Address"
                name="dev_address"
                id="address"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Address is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Address",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                type="select"
                //label="Country*"
                placeholder="Select Country"
                name="dev_country"
                size="sm"
                id="country"
                options={[
                  { key: "United States", value: "United States" },
                  { key: "Australia", value: "Australia" },
                  { key: "Canada", value: "Canada" },
                  { key: "India", value: "India" },
                ]}
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "Country is required",
                })}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="City*"
                placeholder="City"
                name="dev_city"
                id="city"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "City is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid City",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="State*"
                placeholder="State"
                name="dev_state"
                id="state"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "State is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid State",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Zip Code*"
                placeholder="Zip Code"
                name="dev_zip"
                id="zipCode"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "Zip Code is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Zip Code",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row className="my-2">
            <Col className="">
              <p className="ml-3 mb-1 fs--1">
                  <Input checked={isTCReaded} type="checkbox" onChange={(e)=>{
                    setIsTCReaded(!isTCReaded)
                  }}/>
                <span className="fw-semi-bold">
                  By clicking Register, you agree to our SIKKA API
                  <a
                    href="https://www.sikkasoft.com/api-license-agreement"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    terms & conditions
                  </a>
                  .{" "}
                </span>
              </p>
            </Col>
          </Row>

          <div
            className="mt-2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              className={`w-100 sai_button`}
              size={"md"}
              disabled={!isTCReaded || step == 2}
              type="submit"
            >
              Continue
            </Button>
          </div>
        </Form>
      ) : (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row form>
            <Col className="auth-input-form mt-1 mb-2">
              <SikkaSelect
                classNamePrefix="react-select"
                placeholder="You have selected Sikka API for*"
                options={licenseType?.map((option, index) => {
                  return {
                    value: option.plan_id,
                    label: option.plan_name,
                  };
                })}
                value={defaultSelectedPlan}
                onChange={(selectedOption) => {
                  setValue("plan_id", selectedOption.value);
                  setDefaultSelectedPlan(selectedOption);
                }}
                id={"plan_id"}
                name={"plan_id"}
                innerRef={register("plan_id", {
                  required: "Plan ID is required",
                })}
              />
            </Col>
          </Row>
          <Row form className="mt-1 mb-1">
            <Col className="auth-input-form">
              <FormGroup check>
                <Input
                  id="dantal-llm"
                  name="dental-llm"
                  type="checkbox"
                  // value={isDentalLlmSelected}
                  onChange={(e) => {
                    setIsDentalLlmSelected(!isDentalLlmSelected);
                  }}
                  checked={isDentalLlmSelected}
                />
                <Label check for="dantal-llm" className="ml-2">
                  I am interested in {from_where}{" "}
                  <FontAwesomeIcon
                    id="dental_llm_tooltip"
                    style={{ marginLeft: "5px", cursor: "pointer" }}
                    icon={faInfoCircle}
                  />
                  <Tooltip
                    placement={"top"}
                    isOpen={tooltipOpen}
                    target={"dental_llm_tooltip"}
                    toggle={toggle}
                  >
                    Please select the checkbox if you are interested in
                    DentalLLM/Synthetic Dental Data.
                  </Tooltip>
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                // label="Full Name*"
                name="dev_name"
                id="developerName"
                placeholder="Full Name"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Full Name is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Developer Name",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Email*"
                placeholder="Email"
                id="username"
                name="username"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Email must be valid",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Password*"
                placeholder="Password"
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Password is required",
                  pattern: {
                  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/,
                  message:
                  "Password should contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (including -) and be at least 8 characters long.",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Confirm Password*"
                placeholder="Confirm Password"
                id="confirmPassword"
                name="confirm_password"
                size="sm"
                className="fs--1"
                type="password"
                autoComplete="new-password"
                innerRef={register({
                  required: "Confirm Password is required",
                  validate: (value) =>
                    value === watch("password") || "Passwords don't match.",
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Address*"
                placeholder="Address"
                name="dev_address"
                id="address"
                size="sm"
                className="fs--1"
                innerRef={register({
                  required: "Address is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Address",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                type="select"
                //label="Country*"
                placeholder="Select Country"
                name="dev_country"
                size="sm"
                id="country"
                options={[
                  { key: "United States", value: "United States" },
                  { key: "Australia", value: "Australia" },
                  { key: "Canada", value: "Canada" },
                  { key: "India", value: "India" },
                ]}
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "Country is required",
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="State*"
                placeholder="State"
                name="dev_state"
                id="state"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "State is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid State",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="City*"
                placeholder="City"
                name="dev_city"
                id="city"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "City is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid City",
                  },
                })}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Zip Code*"
                placeholder="Zip Code"
                name="dev_zip"
                id="zipCode"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "Zip Code is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Zip Code",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form className="mt-3 mb-2">
            <Col className="auth-input-form">
              <MaskedInput
                mask={[
                  "(",
                  /\d/,
                  /\d/,
                  /\d/,
                  ")",
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                guide={false}
                placeholder="Mobile number"
                id={`mobileNo`}
                name={`mobileNo`}
                render={(ref, props) => {
                  return (
                    <>
                      <Input
                        type="text"
                        innerRef={ref}
                        errors={errors}
                        {...props}
                        size={"sm"}
                      />
                    </>
                  );
                }}
                {...register(`mobileNo`, {
                  required: "Mobile Number is required",
                  validate: (value) => {
                    const cleanedNumber = devMobile.replace(/[^\d]/g, "");

                    return (
                      cleanedNumber.length > 9 ||
                      "Invalid mobile number. Please enter a valid 10-digit mobile number."
                    );
                  },
                })}
                defaultValue={registerFormValues?.["dev_mobile"]}
                value={devMobile}
                onChange={(e) => {
                  setDevMobile(e.target.value);
                  setValue(e.target.name, e.target.value);
                }}
              />
              <SikkaError
                error={errors["mobileNo"]?.message}
                className="mt-1"
              />
            </Col>
            <Col className="auth-input-form">
              <MaskedInput
                mask={[
                  "(",
                  /\d/,
                  /\d/,
                  /\d/,
                  ")",
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                guide={false}
                placeholder="Phone number"
                id={`phoneNumber`}
                name={`phoneNumber`}
                render={(ref, props) => {
                  return (
                    <>
                      <Input
                        type="text"
                        innerRef={ref}
                        errors={errors}
                        {...props}
                        size={"sm"}
                      />
                    </>
                  );
                }}
                {...register(`phoneNumber`, {
                  required: "Phone Number is required",
                  validate: (value) => {
                    const cleanedNumber = devPhone.replace(/[^\d]/g, "");

                    return (
                      cleanedNumber.length > 9 ||
                      "Invalid phone number. Please enter a valid 10-digit phone number."
                    );
                  },
                })}
                defaultValue={registerFormValues?.["dev_phone"]}
                value={devPhone}
                onChange={(e) => {
                  setDevPhone(e.target.value);
                  setValue(e.target.name, e.target.value);
                }}
              />
              <SikkaError
                error={errors["phoneNumber"]?.message}
                className="mt-1"
              />
            </Col>
          </Row>

          <Row form>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="WebSite URL*"
                placeholder="WebSite URL"
                name="dev_site_url"
                id="webSite"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "WebSite URL is required",
                  pattern: {
                    value: urlRegex,
                    message: "Invalid WebSite URL",
                  },
                })}
                // disabled={detailsFromInviteLink?.dev_site_url}
                errors={errors}
              />
            </Col>
          </Row>

          <Row form className="mb-3">
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Company Name*"
                placeholder="Company Name"
                name="partner_name"
                id="companyName"
                size="sm"
                className="input-spin-none fs--1"
                innerRef={register({
                  required: "Company Name is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Company Name",
                  },
                })}
                // disabled={detailsFromInviteLink?.partner_name}
                errors={errors}
              />
            </Col>

             <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Referred By"
                placeholder="Referred By"
                name="referred_by"
                id="referredBy"
                size="sm"
                className="input-spin-none fs--1"
                  maxLength={250}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 250) {
                      setValue("referred_by", value);
                    }
                  }}
                innerRef={register({
                  required: false,
                    maxLength: {
                      value: 250,
                      message: "Referred By must not exceed 250 characters",
                    },
                })}
                // disabled={detailsFromInviteLink?.referred_by}
                errors={errors}
              />
            </Col>
            <Col className="auth-input-form">
              <SikkaInput
                onBlur={(e) => {
                  setValue(e.target.name, e.target.value?.trim());
                }}
                //label="Purpose for apps*"
                placeholder="Purpose for apps"
                name="dev_purpose"
                id="purpose"
                size="sm"
                className="input-spin-none fs--1"
                  maxLength={250}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 250) {
                      setValue("dev_purpose", value);
                    }
                  }}
                innerRef={register({
                  required: "Purpose for apps is required",
                    maxLength: {
                      value: 250,
                      message: "Purpose must not exceed 250 characters",
                    },
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid Purpose",
                  },
                })}
                // disabled={detailsFromInviteLink?.dev_purpose}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col className="">
              <p className="mb-1 fs--1">
                <span className="fw-semi-bold">
                  By clicking Register, you agree to our SIKKA API
                  <a
                    href="https://www.sikkasoft.com/api-license-agreement"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    terms & conditions
                  </a>
                  .{" "}
                </span>
              </p>
            </Col>
          </Row>

          <div
            className="mt-2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              className={`w-100`}
              size={"md"}
              disabled={step == 2}
              type="submit"
            >
              {isTokenExist || (inviteQKey && inviteTKey)
                ? "Register"
                : step == 1
                ? "Next  "
                : "Register "}{" "}
              <FontAwesomeIcon icon={faRightLong} />
            </Button>
          </div>
        </Form>
      )}
    </>
  );
};

export default withRedirect(RegistrationFormNew);
